import React, { FC } from 'react';

import { Link } from '@/core/routing/components/Link';
import { isB2B } from '@/core/settings/utils';
import { ProductCard as TamagoshiProduct } from '@/core/tamagoshi/ProductCard/ProductCard';
import { getCdnURL } from '@/domains/care/helpers';
import { useTrackViewedElement } from '@/domains/core/tracking/hooks/useTrackViewedElement';
import { translations } from '@/domains/productDiscovery/ProductCard/translations';
import { type ProductCardFragment } from '@/domains/productDiscovery/Recommendation/services/graphql/generated/productCard.fragment.generated';
import {
  createProductUrl,
  getDeliveryLabels,
  getMerchLabels,
} from '@/productDiscovery/Recommendation/components/PlaylistGraphQL/utils';
import { mapCurrency } from '@/shoppingCart/AddToCart/utils/mapCurrency';

import styles from './productCard.module.scss';

interface Props {
  product: ProductCardFragment;
  index: number;
  onDisplay: (index: number, product: ProductCardFragment) => void;
  onClick: (index: number, product: ProductCardFragment) => void;
}

export const ProductCardGraphQL: FC<Props> = ({
  product,
  index,
  onDisplay,
  onClick,
}) => {
  const cdn = getCdnURL();

  const [ref] = useTrackViewedElement(() => onDisplay(index, product));

  return (
    <Link
      href={createProductUrl(product)}
      onClick={() => onClick(index, product)}
      className={styles.productCardWrapper}
    >
      <TamagoshiProduct
        b2b={isB2B()}
        brandImageSrc={product.sku.masterProduct.brand?.logo}
        brandName={product.sku.masterProduct.brand?.title}
        displayDeliveryLabel
        imageSrc={`${cdn}${product.sku.images[0].thumbnailUrl}`}
        light
        price={product.pricing.sellPrice.amountVatIncluded}
        rating={product.productRating?.average}
        ratingCount={product.productRating?.total}
        ref={ref}
        retailPrice={product.pricing.retailPrice?.amountVatIncluded}
        title={product.sku.title}
        vertical
        currency={mapCurrency(product.pricing.sellPrice.currency)}
        merchandising={getMerchLabels(product.commercialAnimation)}
        deliveryLabel={getDeliveryLabels(product.coldDeliveryOffers)}
        translations={translations}
        imageLoading={'lazy'}
      />
    </Link>
  );
};

ProductCardGraphQL.displayName = 'ProductCardGraphQL';
